import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white
} from './helpers';

export const bakerhouse: TrackingPageModel = {
  languageMenu: getLanguageMenu('Montserrat', '#000000ff', '700'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Libre Franklin', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  background: {
    color: '#ffffff',
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/baker-house.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#e10a56ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 4,
    borderWidth: 0,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Poppins', '#32141eff', '700')
  },
  orderCard: {
    backgroundColor: '#ffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 25,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Montserrat', '#e10a56ff', '700')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Poppins', '#000000ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Montserrat', '#808080ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Montserrat', '#e10a56ff', '500')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 4,
    borderColor: '#5780ff',
    borderWidth: 0,
    borderRadius: 25,
    backgroundColor: '#ffeceeff',
    shadow: 'none',
    button: {
      on: true,
      backgroundColor: '#e10a56ff',
      borderColor: '#2E4068',
      borderRadius: 22,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Montserrat', white, '700')
    },
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#2E4068',
      borderRadius: 4,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Poppins', '#000000', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Nunito Sans', '#e10a56ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#e10a56ff',
    borderColor: '#2e4068ff',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Montserrat', '#ffffffff')
  },
  detailsButton: {
    backgroundColor: '#e10a56ff',
    borderColor: '#5780ff',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Montserrat', white, '700')
  },
  trackButton: {
    backgroundColor: '#e10a56ff',
    borderColor: '#ee7227',
    borderRadius: 22,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Poppins', white, '700')
  },
  pageScroll: {
    scrollColor: '#2E4068',
    borderRadius: 2,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/baker-house-logo.png')),
  socialIcons: getSocialIcons('#e10a56ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffff',
    borderColor: '#d3d7e0ff',
    borderRadius: 20,
    borderWidth: 0,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Nunito', '#000000ff')
  },
  footer: {
    linksColor: '#e10a56ff',
    linksUnderline: false,
    backgroundColor: white,
    ...getFooterItems(),
    ...getFontConfig('Montserrat', '#e10a56ff', '700')
  },
  header: {
    backgroundColor: '#ffeceeff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 25,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#e10a56ff',
        borderColor: '#5780ffff',
        borderRadius: 16,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Montserrat', white, '700')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Montserrat', '#000000', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Montserrat', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Montserrat', '#6f788aff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('baker-house'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#e10a56ff',
      arrowSize: 30
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 25,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#e10a56ff',
        borderColor: '#5780ffff',
        borderRadius: 16,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Montserrat', white, '700')
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Montserrat', '#000000', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Montserrat', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Montserrat', '#6f788aff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('baker-house'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#e10a56ff',
      arrowSize: 30
    }
  },
  seoTitle: ''
};
